import { useNavigate, useParams } from "react-router-dom";
import { defaultImgs } from "../../utils/defaultImages";
import { getUserAvatar } from "../../utils/getMedia";
import GetOfferSetting from "./GetOfferSetting";
import starIcon from "../../asset/images/starIcon.png";
import { Offer, Promoter } from "../../types";
import { routes } from "../../routes/routes";

import styles from "./offers.module.scss";

export default function OfferCard({
  cityName,
  promoterOffers,
}: {
  cityName: string;
  promoterOffers: { promoter: Promoter; offers: Offer[] };
}) {
  const { id } = useParams();
  const navigate = useNavigate();

  const goToOfferDetailsPage = (offerId: string, selectedOffer: Offer) => {
    if (cityName && id) {
      navigate(routes.OfferDetails(id, offerId), {
        state: {
          promoter: promoterOffers.promoter,
          city: cityName,
          offer: selectedOffer,
        },
      });
    }
  };
  return (
    <div className={styles.cardOfferContainer}>
      <div className={styles.cardOfferAvatar}>
        <img
          src={getUserAvatar(promoterOffers.promoter.id) ?? defaultImgs.Avatar}
          alt=""
          onError={(event) => { (event.target as HTMLImageElement).src = defaultImgs.Avatar; }}
        />
      </div>
      <div className={styles.cardOfferBox}>
        <div className={styles.senderInfoBox}>
          <span className={styles.senderName}>{promoterOffers.promoter.FirstName}</span>
          <div className={styles.ratingBox}>
            <img src={starIcon} alt="Rating" />
            <span>{`Rating: ${Number(promoterOffers.promoter.Rating).toFixed(1)}`}</span>
          </div>
        </div>
        {promoterOffers.offers.map((el) => (
          <div
            key={el.id}
            className={styles.offerInfoBox}
            onClick={() => goToOfferDetailsPage(el.id, el)}
          >
            <div className={styles.textInfoBox}>
              <span>{el.clubName}</span>
              <span>{el.offerType}</span>
            </div>
            <div className={styles.iconInfoBox}>
              {el.options?.map((option) => (
                <GetOfferSetting key={option} option={option} isIcon />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
